/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://xhnfy7qnvf.execute-api.eu-west-1.amazonaws.com/macpoddash",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://3xdxofdnvncp3dj3yafzuzv3n4.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:9e9107b4-6631-4679-ba0e-584769c6b36c",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_l3kwSkrtc",
    "aws_user_pools_web_client_id": "2ue1v61ofr43leebeusbbgg745",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "mac-pod-chain2234241-macpoddash",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
